import React from 'react';
import {observer} from 'mobx-react';
import {RadioButton, RadioButtonGroup} from 'components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const HolidayDurationSelector = observer(({uiState}) => {
  const {currentHoliday, errors} = uiState;

  return (
    <div className="clearfix table py1">
      <div className="col-5 table-cell align-top">
        <FormattedMessage id='time_off.holidays.Duration'/>
      </div>
      <div className="col-7 table-cell">
        <RadioButtonGroup
          name={'duration'}
          selectedValue={currentHoliday.duration}
          onChange={(name, value) => currentHoliday.merge({duration: value})}
          errorMessage={errors.duration}
          className={'clearfix table pt1'}
        >
          <RadioButton className='block' value='full_day'>{t('time_off.holidays.Full Day')}</RadioButton>
          <RadioButton className='block pt1' value='half_day'>{t('time_off.holidays.Half Day')}</RadioButton>
        </RadioButtonGroup>
    </div>
  </div>
  );
});

export default HolidayDurationSelector;
